<section class="about" id="about">
  <div class="container">
    <div class="about__inner">

      <div class="about__content">
        <span class="section-tag">{{ t().about_tag }}</span>
        <h2 class="section-title">{{ t().about_title }}</h2>
        <p class="section-subtitle">{{ t().about_desc1 }}</p>
        <p class="section-subtitle">{{ t().about_desc2 }}</p>

        <div class="about__numbers">
          @for (s of stats(); track s.label) {
            <div class="num-item">
              <strong>{{ s.num }}</strong>
              <span>{{ s.label }}</span>
            </div>
          }
        </div>

        <a href="#contact" class="btn-primary" style="display:inline-flex; margin-top: 2rem;">
          {{ t().about_cta }}
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>

      <div class="about__steps">
        @for (step of steps(); track step.num) {
          <div class="step-item">
            <div class="step-num">{{ step.num }}</div>
            <div class="step-body">
              <h4>{{ step.title }}</h4>
              <p>{{ step.desc }}</p>
            </div>
          </div>
        }
      </div>

    </div>
  </div>
</section>
